import React from "react";
import { OverlayTrigger } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";
import Utils from "../../../core/utilities/Utils";
import "./AnomalyInfoTip.scss";

const AnomalyInfoTip = ({ text, placement = "top", className = "" }) => {
  if (!text) return null;

  return (
    <OverlayTrigger
      placement={placement}
      overlay={Utils.renderTooltip(text)}
    >
      <span
        className={`anomaly-info-tip${className ? ` ${className}` : ""}`}
        tabIndex={0}
        role="img"
        aria-label={text}
        onClick={(e) => e.stopPropagation()}
      >
        <BsInfoCircle />
      </span>
    </OverlayTrigger>
  );
};

export default AnomalyInfoTip;
